import { render, staticRenderFns } from "./RouterTab.vue?vue&type=template&id=c47627ac&"
import script from "./RouterTab.vue?vue&type=script&lang=js&"
export * from "./RouterTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c47627ac')) {
      api.createRecord('c47627ac', component.options)
    } else {
      api.reload('c47627ac', component.options)
    }
    module.hot.accept("./RouterTab.vue?vue&type=template&id=c47627ac&", function () {
      api.rerender('c47627ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/views/router/RouterTab.vue"
export default component.exports